export default {
    core: {
        colors: {
            core_white: 'white',
            core_black: 'black',
            core_gray: 'gray',
        },
        mediaQuery: {
            core_DesktopSizeXL: '2560px',
            core_DesktopSizeL: '1920px',
            core_DesktopSizeM: '1510px',
            core_DesktopSizeS: '1440px',
            core_DesktopSizeXS: '1280px',
            core_TabletSize: '1024px',
            core_TabletSizeS: '768px',
            core_DesktopSizeXLMin: '2559px',
            core_DesktopSizeLMin: '1919px',
            core_DesktopSizeMMin: '1509px',
            core_DesktopSizeSMin: '1439px',
            core_DesktopSizeXSMin: '1279px',
            core_TabletSizeMin: '1023px',
            core_TabletSizeSMin: '767px',
        },
    },
};
//# sourceMappingURL=theme.js.map